import { useAtom } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import styled, { css } from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import * as TrendUI from '@root/entities/trend/ui'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'

import { ExploreTwoRowsTextCell } from './explore-two-rows-text-cell'

import type { PairMetrics, PairModel } from '@root/entities/pair'

export const VolumeCell = ({
  pair,
  period,
}: {
  pair: PairModel
  period: PairMetrics.MetricsSpan
}) => {
  const [volumeUsd] = useAtom(pair.stats[period].volumeUsd)
  const [volumeInUsdTrendDistinctOrdering] = useAtom(
    pair.ui.volumeInUsdTrendDistinctMap[period],
  )
  const [netVolumeInUsd] = useAtom(pair.stats[period].netVolumeInUsd)
  const volumeTrend =
    volumeInUsdTrendDistinctOrdering === undefined
      ? Trend.Neutral
      : Trend.fromOrdering(volumeInUsdTrendDistinctOrdering)

  return (
    <ExploreTwoRowsTextCell
      gap={2}
      firstRow={
        <FirstRow>
          <FlashTextContentDistinct>
            <Numeric
              value={volumeUsd}
              preset="currency-amount-short"
              currency="$"
            />
          </FlashTextContentDistinct>
          <AnimatePresence>
            {volumeInUsdTrendDistinctOrdering !== undefined &&
            volumeInUsdTrendDistinctOrdering !== 0 ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.15 }}
                css={css`
                  display: grid;
                `}
              >
                <TrendUI.TrendTriangle trend={volumeTrend} size={12} />
              </motion.div>
            ) : undefined}
          </AnimatePresence>
        </FirstRow>
      }
      secondRow={
        <Net $trend={Trend.of(netVolumeInUsd)}>
          <FlashTextContentDistinct>
            <Numeric
              value={netVolumeInUsd}
              preset="currency-amount-short"
              currency="$"
            />
          </FlashTextContentDistinct>
        </Net>
      }
    />
  )
}
const FirstRow = styled.div`
  width: fit-content;
  display: flex;
  gap: 2px;
`
const Net = styled.div<{ $trend: Trend.Trend }>`
  color: ${({ $trend }) => TrendUI.colorCSSVar($trend, { mode: 'candle' })};
  width: fit-content;
`
